import { BehaviorSubject, Subject } from 'rxjs';
import { AxInit, ModuleName } from "../../../Lib/AxSystem/AxInit";
import { AxLoad } from "../../../Lib/AxSystem/AxLoad";
import { AxTab } from "../../../Limestone/AxPortlet/AxTab";
import { CompPackOrderTicketValues } from "../../../Models/ComplexPackages/BookingOptions/CompPackOrderTicketValues";
import { TimeSlotConfig } from '../../../Models/Contingent/TimeSlotProductConfig';
import { ITimeSlot, TimeSlotEntry } from "../../../Models/Reservation/TimeSlot";
import { TimeSlotKey } from "../../../Models/Reservation/TimeSlotKey";
import { TicketType } from "../../../Models/Tickets/TicketType";
import { ComplexPackageBookingOptions } from "../ComplexPackageBookingOptions";

@ModuleName("ComplexPackageBookingTicketsOptions")
export class ComplexPackageBookingTicketsOptions implements AxInit {
    protected datePattern: string;
    protected cpBookingOptions: ComplexPackageBookingOptions = AxLoad.GetModule<ComplexPackageBookingOptions>("ComplexPackageBookingOptions");

    public InteractionSubject: BehaviorSubject<Element> = new BehaviorSubject(null);
    public SubmitSubject: Subject<Element> = new Subject<Element>();
    public timeSlotsConfigs: TimeSlotConfig[] = [];
    // Manages all timeslots for each package positionNr.
    public availabeTimeSlots: PackageNrAvailableTimeSlots = {};
    // Manages the selected timeslots for each package positionNr.
    public selectedTimeSlots: PackageNrSelectedTimeSlots = {};

    private _AxTab: AxTab = new AxTab();

    AxInit(init: initData): void {
        this.datePattern = init.datePattern;
        this.timeSlotsConfigs = JSON.parse(init.timeSlotsConfigs !== '' ? init.timeSlotsConfigs : '[{}]');
        const ticketTypes = JSON.parse(init.ticketTypes && init.ticketTypes !== '' ? init.ticketTypes : '[{}]');

        ticketTypes.forEach((ticketType: TicketType) => this.loadTicket.call(this, ticketType));
    }

    nextTab(): void {
        const activeTab = $('.tv4_contingent__selection-portlet .ax-tabs li.active');
        $('.prod_selection__summary-next').fadeOut('fast');

        this._AxTab.ActivateTab(activeTab.next().attr('data-target'));
    }

    loadTicket(ticketType: TicketType): void {
        const {
            projNr,
            poolNr,
            ticketTypeNr,
            personTypeNr,
            hasTimeSlots,
            packagePositionNr,
        } = ticketType;
        const ticketsSlotsTag = `#compPack_products_ticket_holder_${ticketType.projNr}_${ticketType.poolNr}_${ticketType.ticketTypeNr}`;
        const $hiddenViewDataHolder = $(ticketsSlotsTag).find('.timeSlots_ViewData');
        const timeSlotsViewData = $($hiddenViewDataHolder).val()?.toString() || '';
        const timeSlotList: TimeSlotEntry[] = JSON.parse(timeSlotsViewData && timeSlotsViewData !== '' ? timeSlotsViewData : '[{}]');
        const selector: string = '.tv4_contingent__selection-portlet .ax-tabs';
        const ticketValues = new CompPackOrderTicketValues(projNr, ticketTypeNr, poolNr, personTypeNr, packagePositionNr, hasTimeSlots);

        if (!ticketType.hasTimeSlots) {
            this.cpBookingOptions.bookingValuesList.forEach((bookingValues) => {
                bookingValues.ticketOrderValues.push(ticketValues);
            });
            return;
        }

        if ($(selector).length > 0) {
            this._AxTab.Init(selector);
            $('.prod_selection__selection-next-submit').on('click', () => this.nextTab());
        }

        //call constructor for class methods
        //If not null pointers exceptions will be raised.
        for (let entry of timeSlotList) {
            const { timeSlotKey } = entry;
            entry.timeSlotKey = new TimeSlotKey(timeSlotKey?.timeSlotGroupKey, timeSlotKey?.timeSlotKey1, timeSlotKey?.timeSlotKey2);
        }

        if (!this.availabeTimeSlots[packagePositionNr]) {
            this.availabeTimeSlots[packagePositionNr] = [];
        }
        this.availabeTimeSlots[packagePositionNr] = timeSlotList;

        if (!this.selectedTimeSlots[packagePositionNr]) {
            this.selectedTimeSlots[packagePositionNr] = [];
        }

        this.initTimeSlotListeners(ticketTypeNr, packagePositionNr);

        this.cpBookingOptions.bookingValuesList.forEach((bookingValues) => {
            bookingValues.ticketOrderValues.push(ticketValues)
        });

        $('.product_selection__allotment_lang button').on('click', (e) => {
            this.activateLanguage($(e.target).data('langid'));
        });

        this.activateLanguage($('.product_selection__allotment_lang button')?.first()?.data('langid') ?? $('.product_selection__allotment_selection')?.first()?.data('langid') ?? 0);
    }

    initTimeSlotListeners(
        ticketTypeNo: number,
        packagePosNr: number
    ): void {
        //Only Multicontingent stuff
        if ($('.tv4_contingent__selection-header').length > 0) {
            $(`.product_selection__timeSlot_switch`).on('click', (e) => {
                const $currentTarget = $(e.currentTarget);
                const timeSlotGroupKey = Number($currentTarget.attr('data-target'));

                if ($currentTarget.is(':checked')) {
                    const selectedIndex =  this.selectedTimeSlots[packagePosNr].findIndex((i) => i.timeSlotKey.timeSlotGroupKey == timeSlotGroupKey);

                    if (selectedIndex > -1) {
                        const tmpSlot = this.selectedTimeSlots[packagePosNr][selectedIndex];
                        const tmpSlotEntryTemp = this.getTimeSlot(tmpSlot.timeSlotKey, packagePosNr);
                        this.selectNearestTimeSlots(tmpSlotEntryTemp, packagePosNr);
                    }
                } else {
                    $(`.product_selection__timeSlot_danger[data-target="${timeSlotGroupKey}"]`).addClass('d-none');
                }
            });
        }

        for (let slot of this.availabeTimeSlots[packagePosNr]) {
            const $timeButton = $('.product_selection__allotment_selection .product_selection__allotment_time-container button'
                + `[data-ticketNo="${ticketTypeNo}"]`
                + `[data-timeSlotGroupKey="${slot.timeSlotKey.timeSlotGroupKey}"]`
                + `[data-timeSlotKey1="${slot.timeSlotKey.timeSlotKey1}"]`
                + `[data-timeSlotKey2="${slot.timeSlotKey.timeSlotKey2}"]`);
            slot.day = moment(slot.date, 'YYYY-MM-DD');
            slot.elem = $timeButton?.get(0);

            const oldStatus: string = $timeButton.attr('data-contingentstatus');
            let newStatus: string = '';

            $timeButton.removeClass(`ax-fill-${oldStatus}-500`);
            $timeButton.removeClass(`ax-outline-${oldStatus}-500`);

            if (slot.availableSlots != 0 && slot.availableSlots >= 1) {
                if ((slot.availableSlots - 1) <= slot.warningThreshold) {
                    newStatus = 'red';
                } else if ((slot.availableSlots - 1) <= slot.limitedThreshold) {
                    newStatus = 'orange';
                } else {
                    newStatus = 'green';
                }
                $timeButton.attr('data-contingentstatus', newStatus);

                if (this.selectedTimeSlots[packagePosNr].filter(x => x.timeSlotKey.equal(slot.timeSlotKey)).length > 0) {
                    $timeButton.addClass(`ax-fill-${newStatus}-500`);
                } else {
                    $timeButton.addClass(`ax-outline-${newStatus}-500`);
                }
            } else {
                $timeButton.removeAttr('data-contingentstatus');

                if (this.selectedTimeSlots[packagePosNr].filter(x => x.timeSlotKey.equal(slot.timeSlotKey)).length > 0) {
                    this.deactivateContingent(slot.timeSlotKey, ticketTypeNo, packagePosNr);
                }
            }
        }

        $('.product_selection__allotment_selection button.ax-chip').on('click', (e) => {
            this.selectionContingent(e.target, packagePosNr);
        });
    }

    activateLanguage(langID: number): void {
        $(`.product_selection__allotment_lang button`).removeClass('ax-chip--active');
        $(`.product_selection__allotment_lang button[data-langid=${langID}]`).addClass('ax-chip--active');

        $('.product_selection__allotment_selection').addClass('d-none');
        $(`.product_selection__allotment_selection[data-langid=${langID}]`).removeClass('d-none');
    }

    deactivateContingent(
        timeSlotKey: TimeSlotKey,
        ticketTypeNo: number,
        packagePosNr: number
    ): void {
        const index: number = this.selectedTimeSlots[packagePosNr].findIndex(x => x.timeSlotKey.equal(timeSlotKey));
        if (index > -1) {
            this.selectedTimeSlots[packagePosNr].splice(index, 1);
        }

        $('.product_selection__allotment_selection button'
            + `[data-ticketNo="${ticketTypeNo}"]`
            + `[data-timeSlotGroupKey="${timeSlotKey.timeSlotGroupKey}"]`
            + `[data-timeSlotKey1="${timeSlotKey.timeSlotKey1}"]`
            + `[data-timeSlotKey2="${timeSlotKey.timeSlotKey2}"]`).each((i, el) => {
            const $button: JQuery<Element> = $(el);
            const color: string = $button.attr('data-contingentstatus');
            $button.removeClass(`ax-fill-${color}-500`);
        });
    }

    getTimeSlot(timeSlotKey: TimeSlotKey, packagePosNr: number): TimeSlotEntry {
        return this.availabeTimeSlots[packagePosNr].find((el) => el.timeSlotKey.equal(timeSlotKey));
    }

    checkSuballotmentQuantity(timeSlotKey: TimeSlotKey, packagePosNr: number): boolean {
        const sumQuantity: number = 1;
        const subC = this.getTimeSlot(timeSlotKey, packagePosNr);

        return subC?.availableSlots >= sumQuantity;
    }

    selectNearestTimeSlots(
        timeslot: TimeSlotEntry,
        packagePosNr : number,
    ): void {
        const time = timeslot.time;
        const timeSlotByDay = this.availabeTimeSlots[packagePosNr].filter((timeSlot) => (
            timeSlot.timeSlotKey.timeSlotGroupKey == timeslot?.timeSlotKey.timeSlotGroupKey
                && timeSlot?.day?.format('YYYY-MM-DD') !== timeslot.date
        ));
        let nearestTimeSlot: TimeSlotEntry;
        let alwaysSame = true;

        for (let slotDay of timeSlotByDay) {
            const timeSlotGroupSameDay = this.availabeTimeSlots[packagePosNr].filter((slot) => (
                slot?.timeSlotKey.timeSlotGroupKey == slotDay.timeSlotKey.timeSlotGroupKey && slot?.day?.isSame(slotDay?.day)
            ));
            let currentOffset = 9999;

            for (let tmpSlot of timeSlotGroupSameDay) {
                let offset = time - tmpSlot.time;
                if (offset < 0) {
                    offset = offset * -1;
                }

                if (offset < currentOffset && this.checkSuballotmentQuantity(tmpSlot.timeSlotKey, packagePosNr)) {
                    nearestTimeSlot = tmpSlot;
                    currentOffset = offset;

                    if (offset == 0) {
                        break;
                    }
                }
            }

            if (currentOffset != 0) {
                alwaysSame = false;
            }

            this.selectionContingent(nearestTimeSlot.elem, packagePosNr, false);
        }
        $(`.product_selection__timeslot_danger[data-target="${timeslot.timeSlotKey.timeSlotGroupKey}"]`).toggleClass('d-none', alwaysSame);
    }

    selectionContingent(
        e: Element,
        packagePosNr: number,
        triggerChecks: boolean = true,
    ): void {
        const $elem: JQuery<Element> = $(e);
        const color: string = $elem.attr('data-contingentstatus');
        const timeSlotGroupKey: number = Number($elem.attr('data-timeSlotGroupKey'));
        const timeSlotKey1: string = $elem.attr('data-timeSlotKey1');
        const timeSlotKey2: number = Number($elem.attr('data-timeSlotKey2'));
        const timeSlotKey: TimeSlotKey = new TimeSlotKey(timeSlotGroupKey, timeSlotKey1, timeSlotKey2);
        const checkSuballotmentQuantity = this.checkSuballotmentQuantity(timeSlotKey, packagePosNr);
        const $activeTab = $('.tv4_contingent__selection-portlet .ax-tabs li.active');

        if (checkSuballotmentQuantity) {
            const currentTimeSlot = this.getTimeSlot(timeSlotKey, packagePosNr);

            /// Original behaviour: Click to set makes automatically unset the other selected timeslot.
            /// New behaviour Click to set/unset -> do not allow to set more than max timeslots than configured.
            const config = this.timeSlotsConfigs.find((config) => config.ConfigId == timeSlotGroupKey);
            const isSingleSelect = config.MinimumTimeSlotsAllowed == 1 && config.MaximumTimeSlotsAllowed == 1;

            if (isSingleSelect) {
                this.selectedTimeSlots[packagePosNr]
                    .filter((selected) => (
                        selected?.timeSlotKey.timeSlotGroupKey == timeSlotGroupKey && selected?.day?.isSame(currentTimeSlot.day))
                    )
                    .forEach((timeSlot) => {
                        const $productSelection = $('.product_selection__allotment_selection button'
                            + `[data-timeSlotGroupKey="${timeSlot.timeSlotKey.timeSlotGroupKey}"]`
                            + `[data-timeSlotKey1="${timeSlot.timeSlotKey.timeSlotKey1}"]`
                            + `[data-timeSlotKey2="${timeSlot.timeSlotKey.timeSlotKey2}"]`);
                        const productSelectionColor: string = $productSelection.attr('data-contingentstatus');
                        $productSelection.removeClass(`ax-fill-${productSelectionColor}-500`).addClass(`ax-outline-${productSelectionColor}-500`);
                    });
            }

            ///Original behaviour: find the index of the selected timeslot by timeSlotGroupKey + day only (only 1 timeslot can be selected per day)
            ///New behaviour: find the index of the selected timeslot by timeSlotGroupKey + timeSlotKey1 + timeSlotKey2 + day (multiple timeslots can be selected per day)
            const index: number = isSingleSelect
                ? this.selectedTimeSlots[packagePosNr].findIndex(x => (
                    x.timeSlotKey?.timeSlotGroupKey == timeSlotGroupKey
                    && x?.day?.isSame(currentTimeSlot.day)))
                : this.selectedTimeSlots[packagePosNr].findIndex(x =>
                    x.timeSlotKey.timeSlotGroupKey == timeSlotGroupKey
                    && x.timeSlotKey.timeSlotKey1 == timeSlotKey1
                    && x.timeSlotKey.timeSlotKey2 == timeSlotKey2
                    && x.day.isSame(currentTimeSlot.day));

            if (index > -1) {
                this.selectedTimeSlots[packagePosNr].splice(index, 1);
                $elem.removeClass(`ax-fill-${color}-500`).addClass(`ax-outline-${color}-500`);
            }

            ///Original behaviour: always allow to add a timeslot when clicking on an unselected timeslot (previous selected timeslot will automatically unset)
            ///New behaviour: only allow to add a timeslot if the max allowed timeslots for the config has not been reached yet and index is not found (-1)
            const canAddTimeSlot = isSingleSelect
                ? true
                : this.CanAddTimeSlot(config, packagePosNr, timeSlotKey1) && index == -1;

            if (canAddTimeSlot) {
                this.selectedTimeSlots[packagePosNr].push({ timeSlotKey: timeSlotKey, day: currentTimeSlot.day, time: currentTimeSlot.time });
                $elem.removeClass(`ax-outline-${color}-500`).addClass(`ax-fill-${color}-500`);
            }

            const isChecked = $(`.product_selection__timeSlot_switch[data-target="${timeSlotGroupKey}"]`).prop('checked');
            if (isChecked && triggerChecks) {
                this.selectNearestTimeSlots(currentTimeSlot, packagePosNr);
            }

            this.UpdateBookingValues(packagePosNr);
        }

        if ($activeTab.length > 0) {
            if (!$activeTab.is(':last-child')) {
                if (!this.CheckTimeSlotPackagePos(packagePosNr)) {
                    $('.prod_selection__summary-next').fadeOut('fast');
                }
                else {
                    $('.prod_selection__summary-next').fadeIn('fast');
                }
            }
        }
    }

    GetBaseTimeSlotDict(): PackageNrCountTimeSlots {
        return Object.entries(this.availabeTimeSlots).reduce((acc, [packagePosNr, entry]) => {
            if (!acc[parseInt(packagePosNr)]) {
                acc[parseInt(packagePosNr)] = {};
            }

            acc[parseInt(packagePosNr)] = entry.reduce((acc2, item) => {
                if (!acc2[item.timeSlotKey.timeSlotGroupKey]) {
                    acc2[item.timeSlotKey.timeSlotGroupKey] = {};
                }
                acc2[item.timeSlotKey.timeSlotGroupKey][item.timeSlotKey.timeSlotKey1] = 0
                return acc2;

            }, {});

            return acc;
        }, {});
    }

    GetTimeSlotDict(): PackageNrCountTimeSlots {
        if (!this.selectedTimeSlots) {
            return null;
        }

        return Object.entries(this.selectedTimeSlots).reduce((acc, [packagePosNr, entry]) => {
            entry.forEach(item => acc[parseInt(packagePosNr)][item.timeSlotKey.timeSlotGroupKey][item.timeSlotKey.timeSlotKey1]++);
            return acc;
        }, this.GetBaseTimeSlotDict());
    }

    public CheckTimeSlotPackagePos(packagePosNr: number): boolean {
        if (!this.selectedTimeSlots[packagePosNr]) {
            return false
        }

        let areValidSelectedTimeSlots = this.selectedTimeSlots[packagePosNr] != null;
        const timeSlotDict = this.GetTimeSlotDict();
        if (!timeSlotDict) {
            return false;
        }

        areValidSelectedTimeSlots &&= Object.keys(timeSlotDict[packagePosNr]).every(key => this.CheckTimeSlotKey(packagePosNr, parseInt(key)));

        return areValidSelectedTimeSlots;
    }

    CheckTimeSlotKey(packagePosNr: number, configId: number): boolean {
        const timeSlotDict = this.GetTimeSlotDict();
        if (!timeSlotDict) {
            return false;
        }

        const config = this.timeSlotsConfigs.find(x => x.ConfigId == configId);
        if (!config) {
            return false;
        }

        return Object.values(timeSlotDict[packagePosNr][configId]).every(x =>
            x >= config.MinimumTimeSlotsAllowed
            && x <= config.MaximumTimeSlotsAllowed);
    }

    CanAddTimeSlot(config: TimeSlotConfig, packagePosNr: number, timeSlotKey1: string): boolean {
        const timeSlotDict = this.GetTimeSlotDict();
        if (!timeSlotDict) {
            return true;
        }

        return timeSlotDict[packagePosNr][config.ConfigId][timeSlotKey1] < config.MaximumTimeSlotsAllowed;
    }

    UpdateBookingValues(packagePositionNr: number) {
        this.cpBookingOptions.bookingValuesList.forEach((bookingValues) => {
            const ticketOrder = bookingValues.ticketOrderValues.find(x => x.packagePositionNr);
            if (Boolean(ticketOrder) && ticketOrder.hasTimeSlots) {
                ticketOrder.selectedTimeSlots = this.selectedTimeSlots[packagePositionNr];
            }
        });
    }
}

/**
 * Data structure to put available timeslots for specific packageposNr ticket.
 *     PackageNrAvailableTimeSlots -> [List of TimeSlotEntry]
 * Ex:              1              -> [{TSlotDate: 01/01/2000 10:00 AM}, {TSlotDate: 01/01/2000 10:00 AM}]
 *                  2              -> [{TSlotDate: 01/01/2000 09:00 AM}, {TSlotDate: 01/01/2000 11:00 AM}, {TSlotDate: 01/01/2000 01:00 PM}]
 */
interface PackageNrAvailableTimeSlots { [packagePosNr: number]: TimeSlotEntry[] }

/**
 * Data structure to put selected timeslots for specific packageposNr ticket.
 *      PackageNrSelectedTimeSlots -> [List of ITimeSlot]
 * Ex:             1               -> [{timeSlotKey: {1, '1', 1} day: {01/01/2000 10:00 AM}, time: 1}]
 *                 2               -> [{timeSlotKey: {1, '1', 1} day: {01/01/2000 09:00 AM}, time: 1}, {timeSlotKey: {1, '1', 2} day: {01/01/2000 11:00 AM}, time: 1}]
 */
 interface PackageNrSelectedTimeSlots { [packagePosNr: number]: ITimeSlot[] }

/**
 * Data structure to manage selected timeslots count for each packagePosNr, this is used to validate if the selected timeslots are between the min and max allowed configured in TimeSlotsConfigs.
 *      PackageNrCountTimeSlots -> ConfigId ->  timeSlotKey1 ->  count
 * Ex:              1           ->    1     ->      '1'      ->  1
 *                  1           ->    2     ->      '2'      ->  0
 *                  2           ->    1     ->      '1'      ->  1
 */
interface PackageNrCountTimeSlots { [packagePosNr: number]: { [configId: number]: { [timeSlotKey1: string]: number } } }

export interface initData {
    ticketTypes: string;
    datePattern: string;
    timeSlotsConfigs: string;
}
